import React, {useState, useRef} from "react"
import Button from "react-bootstrap/Button"
import ButtonGroup from "react-bootstrap/ButtonGroup"
import Modal from "react-bootstrap/Modal"

import {uploadFile} from "../utilities/AxiosHelper"

const UploadButton = ({uploadUrl, label, dispatch, reload, helpTitle, helpContent}) => {
    const fileInputRef = useRef(null)
    const [isBulkLoading, setIsBulkLoading] = useState(false)
    const [show, setShow] = useState(false)

    const handleClose = () => setShow(false)
    const handleShow = () => setShow(true)

    const handleBulkLoadClick = () => {
        fileInputRef.current?.click()
    }

    const handleBulkFileSelected = async (event) => {
        const file = event.target.files?.[0]
        if (!file) {
            return
        }

        const formData = new FormData()
        formData.append("file", file)

        try {
            setIsBulkLoading(true)
            const response = await uploadFile(uploadUrl, formData)

            dispatch("showToast", {
                show: true,
                variant: "success",
                text: response?.data?.message || "Facilities loaded successfully",
                timeout: 8000,
            })

            reload()
        } catch (error) {
            let apiMessage = error?.response?.data?.error
            if (error?.response?.data?.missing_columns) {
                apiMessage = `${apiMessage} Columns: ${error?.response?.data?.missing_columns.join(" , ")}`
            }
            if (error?.response?.data?.errors?.length) {
                const errorText = error?.response?.data.errors.map((e) => `Row ${e.row}: ${e.error}`).join("; ")
                apiMessage = `${errorText}`
            }

            dispatch("showToast", {
                show: true,
                variant: "danger",
                text: apiMessage || "Bulk Facility import failed",
                timeout: 10000,
            })
        } finally {
            event.target.value = ""
            setIsBulkLoading(false)
        }
    }

    return (
        <>
            <ButtonGroup>
                <Button
                    variant="primary"
                    onClick={handleBulkLoadClick}
                    disabled={isBulkLoading}
                    data-testid="bulk-load-button"
                >
                    {isBulkLoading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                            Loading...
                        </>
                    ) : (
                        label
                    )}
                </Button>
                <Button variant="secondary" onClick={handleShow} aria-label="Upload Help">
                    <i className="fas fa-info-circle"></i>
                </Button>
            </ButtonGroup>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{helpTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{helpContent}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* hidden input to handle upload */}
            <input
                ref={fileInputRef}
                type="file"
                accept=".csv"
                style={{display: "none"}}
                onChange={handleBulkFileSelected}
            />
        </>
    )
}

export default UploadButton
